import styled from '@emotion/styled';
import type { Prismic } from '@landsbankinn/prismic';
import { Divider, typography } from '@landsbankinn/ui';
import type { FC } from 'react';
import React, { forwardRef } from 'react';

import { animated } from 'react-spring';

interface TextCardProps {
  title: string | null;
  description: React.ReactNode;
  action?: React.ReactNode;
  image?: Prismic.Image;
  style?: any;
}

const Host = styled(animated.div)`
  position: relative;
`;

const Title = styled.div`
  ${typography.h3}
  color: ${(props) => props.theme.colors.foreground};
  margin-bottom: 40px;
`;

const Copy = styled.div`
  ${typography.body}
  margin-bottom: 2em;
  color: ${(props) => props.theme.colors.foreground};
`;

const Action = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const TextCard: FC<TextCardProps> = forwardRef(function TCard(
  { title, description, action, ...rest }: TextCardProps,
  ref,
) {
  return (
    <Host {...rest} title={title ?? undefined} ref={ref as any}>
      <Title>{title}</Title>
      <Divider margin="0 0 17px 0" />
      <Copy>{description}</Copy>
      {action && <Action>{action}</Action>}
    </Host>
  );
});
